export default "__VITE_ASSET__Djdd4bfH__"